package com.ijoin.ui.util

import com.ijoin.deeplink.DeepLinkParser
import com.ijoin.platform.encodeUrlComponent

private const val APPLE_AUTH_START_PATH = "/api/auth/apple/start"
private val MOBILE_SUCCESS_REDIRECT = "${DeepLinkParser.SCHEME}://oauth"

fun buildAppleAuthStartUrl(baseUrl: String, isMobile: Boolean): String {
    val normalizedBaseUrl = baseUrl.trimEnd('/')
    if (!isMobile) {
        return "$normalizedBaseUrl$APPLE_AUTH_START_PATH"
    }
    val redirect = encodeUrlComponent(MOBILE_SUCCESS_REDIRECT)
    return "$normalizedBaseUrl$APPLE_AUTH_START_PATH?success_redirect=$redirect"
}
